import { ButtonWithIcon } from '@/root/components/tuuleliinid'
import { FC } from 'react'

import { useActionsButtonHandlers } from '@/root/shared-hooks/reservation/useActionsButtonHandlers'
import { useGetTranslations } from '@/root/shared-hooks'

interface TicketActionButtonsProps {
  reservationId: number
  reservationToken: string
  allowance?: {
    cancel: boolean
    edit: boolean
  }
  className?: string
}

export const TicketActionButtons: FC<TicketActionButtonsProps> = ({
  className,
  reservationId,
  reservationToken,
  allowance,
}) => {
  const { getTranslation } = useGetTranslations()

  const { onDownload, onPrint, onCancel, onEdit } = useActionsButtonHandlers(reservationId, reservationToken)

  return (
    <div className={`flex justify-around ${className}`}>
      <ButtonWithIcon
        className="text-base-medium-light"
        iconColor="base-medium-light"
        iconType="Download"
        iconWidth={16}
        label={getTranslation('ticketActionButtonsDownload')}
        onClick={onDownload}
      />
      <ButtonWithIcon
        className="text-base-medium-light"
        iconColor="base-medium-light"
        iconType="Print"
        iconWidth={16}
        label={getTranslation('ticketActionButtonsPrint')}
        onClick={onPrint}
      />
      {allowance?.edit && (
        <ButtonWithIcon
          className="text-base-medium-light"
          iconColor="base-medium-light"
          iconType="Pen"
          iconWidth={16}
          label={getTranslation('ticketActionButtonsEdit')}
          onClick={onEdit}
        />
      )}
      {allowance?.cancel && (
        <ButtonWithIcon
          className="text-error-medium-light"
          iconColor="error-medium-light"
          iconType="TrashBin"
          iconWidth={16}
          label={getTranslation('ticketActionButtonsCancel')}
          onClick={onCancel}
        />
      )}
    </div>
  )
}

export default TicketActionButtons
